import { Outlet } from 'react-router'
import { Suspense } from 'react'
import LoadingSpinner from '../../components/LoadingSpinner'

const System = () => {
  return (
    <div className="mcc-content-frame theme-sandman">
      <Suspense fallback={<LoadingSpinner />}>
        <Outlet />
      </Suspense>
    </div>
  )
}

export default System
